import React, {PureComponent} from "react"
import {Hr} from "@irati/ui/src/Layout"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Expander from "@irati/ui/src/Expander"
import {TextButton} from "@irati/ui/src/Button"
import {Label1} from "@irati/ui/src/Labels"
import {Reward} from "@irati/types"
import Markdown from "@irati/ui/src/Markdown"

interface Props extends InjectIntl {
  reward: Reward,
  onClick?: () => void
}

class RewardDeliveryInfo extends PureComponent<Props> {
  render() {
    const {formatMessage, reward, onClick} = this.props

    if (!reward.termsAndConditions) {
      return null
    }

    return (
      <section>
        <Hr small />
        {
          onClick
            ? (
              <TextButton onClick={onClick}>
                <FormattedMessage id="reward.detail.termsAndConditions.title" />
              </TextButton>
            ) : (
              <Expander showText={formatMessage({id: "reward.detail.termsAndConditions.title"})} HeaderLabel={Label1}>
                <Markdown source={reward.termsAndConditions} />
              </Expander>
            )
        }
      </section>
    )
  }
}

export default injectIntl(RewardDeliveryInfo)
